<!-- 网页页尾-->
<template>
  <div class="home_footer">

    <div class="flink"> <span style="margin-right: 20px;">友情<br>链接</span>
      <div style="display: flex;flex-wrap: wrap;">
        <div><a href="http://www.norincogroup.com.cn/" title="中国兵器工业集团有限公司" target="_blank">
          中国兵器工业集团有限公司
          <!-- <img src="http://www.csyice.com/Uploads/201807/5b3c998292766.jpg" alt="中国兵器工业集团有限公司"> -->
        </a></div>
        <div><a href="http://www.sanygroup.com" title="三一集团" target="_blank">
          三一集团
          <!-- <img src="http://www.csyice.com/Uploads/201712/5a436407382f8.png" alt="三一集团"> -->
        </a></div>
        <div><a href="http://www.csrgc.com.cn" title="中国南车股份有限公司" target="_blank">
          中国南车股份有限公司
          <!-- <img src="http://www.csyice.com/Uploads/201712/5a4364463f883.png" alt="中国南车股份有限公司"> -->
        </a></div>
        <div><a href="http://www.buaa.edu.cn" title="北京航空航天大学" target="_blank">
          北京航空航天大学
          <!-- <img src="http://www.csyice.com/Uploads/201712/5a43646e7c0bf.png" alt="北京航空航天大学"> -->
        </a></div>
        <div><a href="http://www.cetc.com.cn/" title="中国电子科技集团有限公司" target="_blank">
          中国电子科技集团有限公司
          <!-- <img src="http://www.csyice.com/Uploads/201807/5b3c9878581dc.jpg" alt="中国电子科技集团有限公司"> -->
        </a></div>
        <div><a href="http://www.kontron.com" title="德国控创" target="_blank">
          德国控创
          <!-- <img src="http://www.csyice.com/Uploads/201712/5a4364e892622.png" alt="德国控创"> -->
        </a></div>

      </div>
    </div>
    <div >
      <div style="margin-right: 50px;">
        <p>站点导航 &nbsp;&nbsp;/&nbsp;&nbsp;Site navigation </p>
        <div class="fnav">
          <div class="menu-item" id="menu-item-1" @click="go_page ('index')">首页 &nbsp;&nbsp;|&nbsp;&nbsp;</div>
          <div class="menu-item" id="menu-item-2" @click="go_page ('aboutUs')">关于我们&nbsp;&nbsp;|&nbsp;&nbsp;</div>

          <div class="menu-item" id="menu-item-3" @click="go_page ('productService','1539415162975424512',0)">移动接入设备&nbsp;&nbsp;|&nbsp;&nbsp;</div>
          <div class="menu-item" id="menu-item-3" @click="go_page ('productService','1636584464106655744',1)">信息系统软件&nbsp;&nbsp;|&nbsp;&nbsp;</div>
          <div class="menu-item" id="menu-item-3" @click="go_page ('productService','1636584565269073920',2)">解决方案&nbsp;&nbsp;|&nbsp;&nbsp;</div>
          <!-- <div class="menu-item" id="menu-item-4" @click="go_page ('news')">新闻动态&nbsp;&nbsp;|&nbsp;&nbsp;</div> -->
          <div class="menu-item" id="menu-item-5" @click="go_page ('contact')">联系我们</div>
        </div>
      </div>
      <div>
        <p>长沙伊测电子科技有限公司</p>
        <p>总机：0731-85303809 &nbsp;&nbsp; 邮箱：<a href="mailto:csyicedianzi@csyice.com">csyicedianzi@csyice.com</a> &nbsp;&nbsp; <a href="https://beian.miit.gov.cn/" target="_blank">湘ICP备18004548号-1</a> &nbsp;&nbsp;&nbsp; </p>
        <p>地址：湖南省长沙市开福区伍家岭街道栖凤路凯乐微谷商务中心 &nbsp;&nbsp; </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    };
  },

  components: {},

  computed: {},

  mounted () { },

  methods: {
    go_page (pageName) {
      this.$store.commit("setShowDetails",false)
      this.$router.push({name: pageName || 'index'})
    }
  }
}

</script>
<style scoped>
.home_footer {
    width: 100%;
    background-color: #f7f8fa;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    /* min-width: 1200px; */
    font-size: 14px;
    color: #606266;
    flex-wrap: wrap;
    padding: 0 20px 0 20px;
}
.flink {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
  /* margin-left: 150px; */

}
.flink>div div{
  margin-right: 10px;
}
.fnav {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}
a {
  color: #606266;
}
.menu-item{
  cursor: pointer;
}
</style>
